import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';

import "./AssignCapsuleModalContent.css";
import AssignCapsuleStep1 from './AssignCapsuleModal/AssignCapsuleStep1';
import AssignCapsuleStep2 from './AssignCapsuleModal/AssignCapsuleStep2';


class AssignCapsuleModalContent extends Component {

    render() {
        return (
            <AssignCapsuleModalForm {...this.props}/>
        );
    }

}

const INITIAL_STATE = {
    showUsers: false,
    myCompany: '',
    currentsUsers: [],
    users: [],
    usersData: [],
    usersToDisplay: [],
    selectedAssignees : {},
    selectedImportance: '',
    selectedTime: '',
    currentState: "STEP1",
    alreadyAssigned : [],
    currentUser : null,
    error: null,
};

class AssignCapsuleModalFormBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    componentDidMount() {

        this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

            if (currentUser === null) {
                return 
            }
        
        let currentUserInfos = await this.props.firebase.db.collection('users').doc(currentUser.uid).get();
        let querySnapshotUsers = await this.props.firebase.db.collection('users').get();
        let querySnapshotAssignments = await this.props.firebase.db.collection('assignments').where('assignedCapsule', '==',this.props.capsuleID).get();

        const myCompany = currentUserInfos.data().company;
        const users = querySnapshotUsers.docs
            .map(doc => doc)
            .filter(user => user.data().company === myCompany)
        const usersData = querySnapshotUsers.docs
            .map(doc => doc.data())
            .filter(user => user.company === myCompany)
        
        
        const alreadyAssigned = querySnapshotAssignments.docs.map(doc => doc.data().targetUser)

        this.setState({
            users, usersData, alreadyAssigned, myCompany, currentUser
        })

    });
    };

    onBack = () => {
        this.setState({currentState: "STEP1"});
    }

    onSubmitSelection = event => {

        this.setState({ currentState: "STEP2" });
        let usersToDisplay = this.state.users.filter(userselect => (
            Object.keys(this.state.selectedAssignees).includes(userselect.id) && this.state.selectedAssignees[userselect.id] === true))
        this.setState({ usersToDisplay });

        event.preventDefault();

        
    }

    onSubmitFinal = event => {
        const { selectedAssignees, myCompany, users, currentUser } = this.state;
        const timestamp = Date.now();
        const currentUserData = users.filter(doc => doc.id === currentUser.uid).map(doc => doc.data())[0]
        let context = this;

        Object.keys(selectedAssignees).forEach(async (user) => {
            const assigneeName = users.filter(doc => doc.id === user).map(doc => doc.data().firstname + " " + doc.data().lastname)[0]

            const assignment = {
                assignedCapsule: context.props.capsuleID, 
                accepted : null,
                from : this.props.firebase.auth.currentUser.uid,
                targetUser : user,
                date : Date.now(),
                timeEstimation: this.state.selectedTime,
                importanceEstimation: this.state.selectedImportance,
                company : myCompany}

            const querysnapshotFilteredAssignments = await this.props.firebase.db
                .collection('assignments')
                .where("assignedCapsule", "==", context.props.capsuleID)
                .where('targetUser', '==', user)
                .get();
            
            const filteredAssignments = querysnapshotFilteredAssignments.docs.map(doc => doc.data())
            if (filteredAssignments.length === 0){
                await this.props.firebase.db
                    .collection('assignments')
                    .add(assignment)
            }
            let newHistoric = {date: timestamp, firstname: currentUserData.firstname, lastname: currentUserData.lastname, picture: currentUserData.image_url_profile, status: "adresse", assignee: assigneeName}
            await this.props.firebase.db.collection('capsules').doc(context.props.capsuleID).collection('historic').add(newHistoric)

        })
        event.preventDefault();
        this.props.openConfirmation()
        this.props.onClose();
        
    };
    
    onSelectAssignee = user => {

        if(this.state.selectedAssignees[user.id] !== null){
            this.setState({
                selectedAssignees: {
                    ...this.state.selectedAssignees,
                    [user.id]: !this.state.selectedAssignees[user.id]
                }
            })
        }
        else {
            this.setState({
                selectedAssignees: {
                    ...this.state.selectedAssignees,
                    [user.id]: true
                }
            })
        }
}

    onChange = event => {
        this.setState({ currentsUsers: [] });
        let user = event.target.value;
        let matchingUsers = this.state.users.filter(userselect => {
            // return (userselect.data().firstname + userselect.data().lastname).toLowerCase().includes(user.toLowerCase()) && !alreadyAssigned.includes(userselect.id)})
            return (userselect.data().firstname + userselect.data().lastname).toLowerCase().includes(user.toLowerCase())})
        if (matchingUsers.length > 0) {
            this.setState({ showUsers: true, currentsUsers: matchingUsers })
        }
        this.setState({ [event.target.name]: event.target.value });
    };

    onRadioSelection = event => {
        if (event.target.name === "importance"){
            this.setState({
                selectedImportance: event.target.value
            });
        }
        else if (event.target.name === "time") {
            this.setState({
                selectedTime: event.target.value
            });
        }
    }

    render() {
        const {
            currentState,
            showUsers,
            currentsUsers,
            selectedAssignees,
            usersToDisplay,
            selectedImportance,
            selectedTime,
            alreadyAssigned
        } = this.state;
    
          return (
              <>
                { currentState === "STEP1" ? 
                    <AssignCapsuleStep1
                    showUsers={showUsers}
                    alreadyAssigned={alreadyAssigned}
                    currentsUsers={currentsUsers}
                    selectedAssignees = {selectedAssignees}
                    onChange = {this.onChange}
                    onSelectAssignee = {this.onSelectAssignee}
                    onSubmitSelection = {this.onSubmitSelection}
                    /> : 
                    <AssignCapsuleStep2
                    usersToDisplay = {usersToDisplay}
                    selectedImportance = {selectedImportance}
                    selectedTime = {selectedTime}
                    onSubmitFinal = {this.onSubmitFinal}
                    onRadioSelection = {this.onRadioSelection}
                    onBack = {this.onBack}
                    /> }
              </>
          );
    }
}


const AssignCapsuleModalForm = withRouter(withFirebase(AssignCapsuleModalFormBase));


export default AssignCapsuleModalContent;
export { AssignCapsuleModalForm};
